// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { itemTemplate, valueTemplate } from '@aytm/app/stats/page/components/lib/templates'

// components
import { Dropdown } from 'primereact/dropdown'

// styles
import style from '@aytm/app/stats/page/sidebar/view-options/styles/ViewOptionsPanel.module.scss'

const Traits = ({ model, data, features, onTraitChange }) => {
  const { trait } = model
  const { traits, variables, pipingVariables, customVariables, virtual } = data

  const traitsOptions = useMemo(() => {
    let options = []

    options = options.concat(
      traits.map(t => {
        return { key: ('age' == t.id && 'age_range') || t.id, text: t.title }
      })
    )

    options = options.concat(
      virtual.map(item => {
        return { key: item.id, text: item.id.toUpperCase() }
      })
    )

    options = options.concat(
      variables.map(key => {
        return { key, text: key }
      })
    )
    options = options.concat(
      pipingVariables.map(key => {
        return { key, text: key }
      })
    )
    options = options.concat(
      customVariables.map(key => {
        return { key, text: key }
      })
    )

    return options
  }, [traits, variables, pipingVariables, customVariables, virtual])

  return (
    <>
      <div className={`${style.row} ${style['section-title']}`}>Split all charts by a demographic</div>
      <div className={`${style.row} p-fluid`}>
        {trait ? (
          <span className={style.delete} onClick={features.view_options.disabled ? null : () => onTraitChange(null)}>
            <i className="icon-aytmfd-delete" />
          </span>
        ) : null}
        <div className="p-field p-col-12">
          <Dropdown
            className="p-dropdown-rounded"
            placeholder="Select..."
            value={trait}
            options={traitsOptions}
            optionValue="key"
            optionLabel="text"
            optionDisabled="disabled"
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
            fixedDropdownDir="bottom"
            disabled={features.view_options.disabled}
            onChange={features.view_options.disabled ? null : event => onTraitChange(event.value)}
          />
        </div>
      </div>
    </>
  )
}

Traits.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  disabled: PropTypes.bool,
  onTraitChange: PropTypes.func
}

Traits.displayName = 'Traits'

export default Traits
